import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { MasterService } from '../service/master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

@Component({
    selector: 'mjigyosyo-app',
    templateUrl: './mjigyosyo.component.html',
    styleUrls: ['mjigyosyo.component.css']
})
export class MJigyosyoComponent implements OnInit {

    @Input() event_id: number;
    title : string = 'マスタメンテナンス - 事業所マスタ';
    page : number = 1;
    all_count:number=0;
    display_per_page:  number = 5;   /* 最大表示件数 */
    isLoaded : boolean = false;
    selected : boolean = false;
    datalist : any = [];
    search : boolean = false;
    selected_event_id : number = null;
    selected_company_id : number = null;
    search_flg = 0;
    page_flg = 0;

    searchCode:any="";
    searchName:any="";
    d_company:any=[];

    send_list_syozoku:any=[];    
    send_list_person:any=[];    
    event:any=[];
    company_list:any=[];
    status_list : any = [];
    status_list_default : any = [];
    ROLE: any = Role;

    constructor(
        private commonService: CommonService,
        private masterService: MasterService,
        public usersService: UsersService,
        private router: Router,
        private location: Location,
        private route: ActivatedRoute,
    ) { }
    
    select_data:any={
        'name_name':'タイトル',
        'name_description':'説明文',
        'name_support':'2文字以上、10文字以内で入力してください。',
        'description_support':'説明文を入力してください',
        'data' : {},
        
    };

    ngOnInit(): void {
        this.selected_event_id = +this.route.snapshot.paramMap.get('eid');
        this.getList();
    };
    clearData (): void{
        this.isLoaded = false;
        this.select_data.data = {};
        this.datalist = [];
    }
    getList(): void {
        this.clearData();
        let param ={
            eid:this.selected_event_id,
            page : this.page,
            display_per_page:this.display_per_page
        };
        this.masterService.getJigyosyo(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.event = res["fuel_results"]['event'];
                if (this.event.length==0){
                    //対象のイベントがないメッセージを表示し、イベント一覧画面へ飛ばす
                    this.commonService.modalOpens(11007,modalresult=>{
                        this.router.navigate(["/event"]);
                        });
                    }

                this.datalist = res["fuel_results"]['jigyosyo'];
                this.all_count = res["fuel_results"]["all_count"];
                this.company_list = res["fuel_results"]['company'];
                this.selected_company_id = res["fuel_results"]['com_id'];
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    searchJigyosyo(c_id:number,textC:any,textN:any,mode:number):void{
        if(textN != null){
            if(textN.match(/[%％_＿\\￥#?]/)){
                if(textN.match(/[%％]/)){
                    textN = textN.replace(/[%％]/g,'$|');
                }else if(textN.match(/[_＿]/)){
                    textN = textN.replace(/[_＿]/g,'$_');
                }else if(textN.match(/[\\]/)){
                    textN = textN.replace(/[\\]/g,'$|_');
                }else if(textN.match(/[￥]/)){
                    textN = textN.replace(/[￥]/g,'$||_');
                }else if(textN.match(/[#?]/)){
                    textN = textN.replace(/[#?]/g,'$||');
                }else{
                    //
                }
            }else{
                //
            }
        }else{
            //
        }
        if(mode == 0){
            this.page = 1;
        }
        let param ={
            cid : c_id,
            page : this.page,
            display_per_page : this.display_per_page,
            code : textC,
            name : textN,
        };
        this.masterService.getJigyosyoList(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                if (res["fuel_results"].length==0){
                    this.commonService.modalOpens(11006,modalresult=>{});
                }else{
                    if((param.code == null || param.code == "") && (param.name == null || param.name == "")){
                        this.search_flg = 0;
                        this.page_flg = 1;
                    }else{
                        this.search_flg = 1;
                        this.page_flg = 1;
                    };
                    this.datalist= res["fuel_results"]['search'];
                    this.all_count = res["fuel_results"]["all_count"];
                    this.selected = false;
                    if(textC == null && textN == null ){
                        this.search = false;
                        this.searchCode = null;
                        this.searchName = null;
                    }
                }
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }

    save():void{this.commonService.modalOpens(50001,
        //保存してもよろしいですか？
        modalresult => {
            if (modalresult == "OK"){
                this.masterService.saveJigyosyo(this.select_data.data)
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        this.commonService.modalOpens(10001,modalresult=>{
                            if (modalresult == "OK"){
                                this.editSelectRowData(undefined);
                                this.searchJigyosyo(this.select_data.data.c_id,null,null,1);
                                this.selected = false;
                            }
                        });
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                });
                
            }else{
                //
            }
        }
    );
    }
    update():void{this.commonService.modalOpens(50001,
        //保存してもよろしいですか？
        modalresult => {
            if (modalresult == "OK"){
                
                this.masterService.updateJigyosyo(this.select_data.data)
                .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            this.commonService.modalOpens(10001,modalresult=>{
                                if (modalresult == "OK"){
                                    this.editSelectRowData(undefined);
                                    this.searchJigyosyo(this.select_data.data.c_id,null,null,1);
                                    this.selected = false;
                                }
                            });
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    },error => {
                        this.commonService.modalOpens(error,modalresult=>{});
                    });
                
            }else{
                //
            }
        }
    );
    }
    cancel():void{
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
                 modalresult => {
                    if (modalresult == "OK"){
                        this.selected = false;
                        this.search = false;
                    }else{
    
                    }
                }
            );
    }
    delete():void{
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    this.masterService.deleteJigyosyo(this.select_data.data)
                    .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002,modalresult=>{
                                    this.selected = false;
                                    this.searchJigyosyo(this.select_data.data.c_id,null,null,1);
                                });
                            }else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                            }else{
                                this.commonService.modalOpens(11003,modalresult=>{});
                            }
                        },error => {
                            this.commonService.modalOpens(error,modalresult=>{});
                        });
                }else{

                }
            }
        );
    }
    // 編集
    edit(row: any): void {
        this.search = false;
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.editSelectRowData(row);
                        //画面上部へ移動
                        window.scrollTo(0, 0);
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }
    editSelectRowData(row: any): void {

        if (row == undefined){
            this.selected = true;
            if(this.datalist.length==0 && this.search_flg == 0){
                this.select_data.data = { 
                    id: null,
                    c_id: this.selected_company_id,
                    code: null,
                    name: null,
                    short: null,
                    sort: null,
                    n_flg: 1
                };
            }else{
                this.select_data.data = { 
                    id: null,
                    c_id: this.selected_company_id,
                    code: null,
                    name: null,
                    short: null,
                    sort: null,
                    n_flg: 0
                };
            }
        }else{
            this.selected = true;
            this.select_data.data = JSON.parse(JSON.stringify(row))
        }
    }
    checkData(name:string){
        switch (name) {
            // 半角英数字（大文字・小文字）
            case "alphanumeric":
                return (name.match(/^[0-9a-zA-Z]+$/)) ? 2 : 1;
        }
        return 1;
    }
    upRow(row:number,data:any) : void{
        let tempdatalist;
            tempdatalist = this.datalist;
        
        if (row==0){//最初

        }else{
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            //１つ前のレコード beforeRecord
            let beforeRecord = tempdatalist[row-1];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            beforeRecord['chk_sort'] = beforeRecord['sort'];

            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = beforeRecord['sort'];
            beforeRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,beforeRecord
            this.masterService.changeOrderJigyosyo([myRecord,beforeRecord])
            .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        tempdatalist.splice(row-1, 2, tempdatalist[row], tempdatalist[row-1]);
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                });
        }
    }
    downRow(row:number,data:any) : void{
        let tempdatalist;
            tempdatalist = this.datalist;

        if (row==tempdatalist.length -1){//最終

        }else{
            //１つ後ろのレコード afterRecord
            let afterRecord = tempdatalist[row+1];
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            afterRecord['chk_sort'] = afterRecord['sort'];
            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = afterRecord['sort'];
            afterRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,afterRecord
            this.masterService.changeOrderJigyosyo([myRecord,afterRecord])
            .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        tempdatalist.splice(row, 2, tempdatalist[row+1], tempdatalist[row]);
                    }else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                    }else{
                        this.commonService.modalOpens(11003,modalresult=>{});
                    }
                },error => {
                    this.commonService.modalOpens(error,modalresult=>{});
                });
            
        }
    }
    check(){
        if(this.selected==true){
            return true
        }else{
            return false
        }
    }
    checkList(code:any,name:string,short:string):boolean{
        if(code==null || code=="" ||name==null || name=="" || short==null || short==""){
            return true;
        }else{
            if(code.match(/^[0-9a-zA-Z]+$/)){
                return false;
            }else{
                return true;
            }
        }
    }
    checkListSearch(name:string,short:string):boolean{
        if((name==null || name=="") && (short==null || short=="")){
            return true;
        }
        return false;
    }
    goBack(): void {
        if(this.selected){
            this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                    if (modalresult == "OK"){
                        this.location.back();
                    }else{
                        return;
                    }
                }
            );
        }else{
            this.location.back();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/a0125-mjigyosyo/mjigyosyo.component.ts